import React from 'react';

import { ACCOUNT_PREFIX_PATH, APP_PREFIX_PATH } from 'constants/route.constant';
import {
	ROOT,
	ADMIN,
	CONTRACTOR,
	PROVIDER,
	USER,
} from 'constants/roles.constant';

const appsRoute = [
	{
		key: 'appsCrm.dashboard',
		path: `${APP_PREFIX_PATH}/crm/dashboard`,
		component: React.lazy(() => import('views/crm/CrmDashboard')),
		authority: [ROOT, ADMIN, USER],
		approved: true,
	},
	{
		key: 'appsCrm.calendar',
		path: `${APP_PREFIX_PATH}/crm/calendar`,
		component: React.lazy(() => import('views/crm/Calendar')),
		authority: [ROOT, ADMIN, USER],
	},
	{
		key: 'appsCrm.customers',
		path: `${APP_PREFIX_PATH}/crm/customers`,
		component: React.lazy(() => import('views/crm/Customers')),
		authority: [ROOT, ADMIN, USER],
		meta: {
			header: 'Customers',
		},
	},
	{
		key: 'appsCrm.customerDetails',
		path: `${APP_PREFIX_PATH}/crm/customer-details`,
		component: React.lazy(() => import('views/crm/CustomerDetail')),
		authority: [ROOT, ADMIN, USER],
		meta: {
			header: 'Customer Details',
			headerContainer: true,
		},
	},
	{
		key: 'appsCrm.mail',
		path: `${APP_PREFIX_PATH}/crm/mail`,
		component: React.lazy(() => import('views/crm/Mail')),
		authority: [ROOT, ADMIN, USER],
		meta: {
			pageContainerType: 'gutterless',
			footer: false,
		},
	},
	{
		key: 'appsCrm.mail',
		path: `${APP_PREFIX_PATH}/crm/mail/:category`,
		component: React.lazy(() => import('views/crm/Mail')),
		authority: [ROOT, ADMIN, USER],
		meta: {
			pageContainerType: 'gutterless',
			footer: false,
		},
	},
	{
		key: 'apps.documents',
		path: `/documents`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	{
		key: 'apps.certifications',
		path: `/certifications`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	/* {
		key: 'appsAccount.settings',
		path: `${ACCOUNT_PREFIX_PATH}/settings/:tab`,
		component: React.lazy(() => import('views/account/Settings')),
		authority: [ADMIN, USER],
		meta: {
			header: 'Settings',
			headerContainer: true,
		},
	}, */
	{
		key: 'appsAccount.invoice',
		path: `${ACCOUNT_PREFIX_PATH}/invoice/:id`,
		component: React.lazy(() => import('views/account/Invoice')),
		authority: [ROOT, ADMIN, USER],
	},
	{
		key: 'appsAccount.activityLog',
		path: `${ACCOUNT_PREFIX_PATH}/activity-log`,
		component: React.lazy(() => import('views/account/ActivityLog')),
		authority: [ROOT, ADMIN, USER],
	},
	{
		key: 'appsAccount.kycForm',
		path: `${ACCOUNT_PREFIX_PATH}kyc-form`,
		component: React.lazy(() => import('views/setup/KycForm')),
		authority: [ROOT, ADMIN, USER],
	},
];

export default appsRoute;
